<div class="unauthorized-container">
  <div class="unauthorized-content">
    <!-- Vericure Logo -->
    <div class="logo-container">
      <img src="assets/VericureLogo.jpeg" alt="Vericure Logo" class="vericure-logo">
    </div>
    
    <!-- Header with Icon -->
    <div class="header-section">
      <h1>Access Denied</h1>
      <p class="subtitle">You are not authorized to use Vericure Hybrid</p>
    </div>

    <!-- User Information Section -->
    <div class="user-info-section" *ngIf="userAccount">
      <h3>Logged In User Information</h3>
      <div class="user-details">
        <div class="user-avatar">
          <i class="fa-solid fa-user"></i>
        </div>
        <div class="user-text">
          <p class="user-name">{{ userName }}</p>
          <p class="user-email">{{ userEmail }}</p>
        </div>
      </div>
    </div>

    <!-- Message Section -->
    <div class="message-section">
      <h3>Why am I seeing this page?</h3>
      <p>You have successfully authenticated with your Microsoft account, but your account does not have the necessary permissions to access Vericure Hybrid. This could be due to:</p>
      <ul>
        <li>Your account hasn't been granted access by an administrator</li>
        <li>Your access has been revoked or expired</li>
        <li>Your account is not part of the authorized user group</li>
      </ul>
      <p class="contact-info">Please contact your system administrator or IT support team to request access to Vericure Hybrid.</p>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-primary" (click)="onLogout()">
        <i class="fa-solid fa-sign-out-alt"></i>
        Logout
      </button>
    </div>
  </div>
</div>
